jQuery(document).ready(function ($) {
    // Show popup when button is clicked
    $('.rul-newsletter-button-wrapper').on('click', function () {
        var modal = $(this).next('.rul-newsletter-modal');
        modal.fadeIn();
    });

    // Close popup when close button is clicked
    $('.rul-newsletter-modal .rul-close-btn').on('click', function () {
        $(this).closest('.rul-newsletter-modal').fadeOut();
        hideSuccessMessage();
    });

    // Close popup when clicking outside the modal content
    $(document).on('click', function (e) {
        if ($(e.target).closest('.rul-newsletter-content, .rul-newsletter-button-wrapper').length === 0) {
            $('.rul-newsletter-modal').fadeOut();
            hideSuccessMessage();
        }
    });

    // Handle form submission
    $(document).on('submit', '.rul-newsletter-form', function (e) {
        e.preventDefault();

        var form = $(this);
        var emailField = form.find('#rul-gb-email');
        var email = emailField.val().trim();
        var successMessage = form.find('.rul-newsletter-success');
        var submitButton = form.find('#rul-gb-submit-btn');
        var loader = form.find('.rul-gb-loader');

        // Email validation regex
        var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

        if (email === '') {
            showErrorMessage('Please enter your email.');
            return;
        }

        if (!emailRegex.test(email)) {
            showErrorMessage('Please enter a valid email.');
            return;
        }

        // Fetch API Token and Group ID from localized data
        var apiToken = rulNewsletterData.api_token;
        var groupId = rulNewsletterData.group_id;

        if (!apiToken || !groupId) {
            showErrorMessage('Subscription settings are not configured correctly.');
            return;
        }

        hideSuccessMessage(); // Hide previous success message
        // Show the loading state
        submitButton.addClass('loading');
        loader.show();

        $.ajax({
            url: 'https://connect.mailerlite.com/api/subscribers',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + apiToken
            },
            data: JSON.stringify({
                email: email,
                groups: [groupId],
                status: 'active' 
            }),
            success: function (response) {
                // Show success message by changing opacity & visibility
                successMessage.css({
                    'opacity': '1',
                    'visibility': 'visible',
                    'color': '' // Reset to default color
                });
                successMessage.find('.rul-success-message').text('Thanks for signing up!');
                emailField.val(''); // Clear input field
            },
            error: function (xhr, status, error) {
                var errorMessage = 'Failed! Please try again.';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                }
                showErrorMessage(errorMessage);
                emailField.val('');
            },
            complete: function () {
                submitButton.removeClass('loading');
                loader.hide();       
            }
        });
    });

    // Hide success message
    function hideSuccessMessage() {
        $('.rul-newsletter-success').css({
            'opacity': '0',
            'visibility': 'hidden'
        });
    }

    // Show error message
    function showErrorMessage(message) {
        var successMessage = $('.rul-newsletter-success');
        successMessage.find('.rul-success-message').text(message);
        successMessage.css({
            'opacity': '1',
            'visibility': 'visible',
            'color': '#ff6b6b' // Light red color for errors
        });
        
        // Auto-hide the error message after 5 seconds
        // setTimeout(hideSuccessMessage, 5000);
    }
});